import Entitlement from "./entitlement/leave_entitlement.store";
import Detail from "./detail/leave_detail.store";
import Assignment from "./assignment/leave_assignment.store";
import Application from "./application/leave_application.store";
import Individual from "./individual/leave_individual.store";

export default {
  modules: { Entitlement, Detail, Assignment, Application, Individual },
};
